import { render, staticRenderFns } from "./BindsUpwardIcon.vue?vue&type=template&id=f7a943e6&"
import script from "./BindsUpwardIcon.vue?vue&type=script&lang=js&"
export * from "./BindsUpwardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports